import { FILTERS_MAP } from '../../../constants';
import { algoliaStringFormatter } from '../../utils/algolia-string-formatter';
import { numberFilters } from '../../utils/number-filters';

interface CheckboxProps {
  routeStateRefinementList: Record<string, string[]>;
  href: string;
  categoryFiltersLabel?: { [key: string]: string };
}
const checkbox = (props: CheckboxProps) => {
  const { routeStateRefinementList, href } = props;

  const numberFilter = numberFilters(href);

  const entries = Object.entries(routeStateRefinementList);

  const newUrl = new URL(href);

  entries.forEach(([key, type]) => {
    const hasAttributePrefix = key.includes('attributes');

    const keyString = key.split('attributes.');

    const typeFilter = hasAttributePrefix
      ? algoliaStringFormatter(keyString[1])
      : FILTERS_MAP[key]?.toLowerCase();

    const reversedType = [...type].reverse();

    reversedType.forEach((value, index) => {
      const formattedValue = value.replace(/ /g, '_');

      let finalValue =
        formattedValue.charAt(0).toUpperCase() + formattedValue.slice(1);

      if (!href.includes(finalValue)) {
        if (index === 0 && numberFilter === 0) {
          newUrl.pathname += `/${typeFilter}/${finalValue}`;
        } else {
          newUrl.searchParams.append(`filter[${typeFilter}]`, finalValue);
        }
      }
    });

    return newUrl.toString();
  });

  return decodeURI(newUrl.toString());
};

export default checkbox;
